const COLUMN_DATA_TYPE = {
    STRING: "STRING",
    NUMERIC: "NUMERIC",
    DATETIME: "DATETIME",
    DATE_TIME: "DATE_TIME",
    BOOLEAN: "BOOLEAN",
    STRING_NULLABLE: "STRING_NULLABLE",
    NUMERIC_NULLABLE: "NUMERIC_NULLABLE",
    DATETIME_NULLABLE: "DATETIME_NULLABLE",
    BOOLEAN_NULLABLE: "BOOLEAN_NULLABLE"
};

const COMPARISON = {
    LIKE: "LIKE",
    EQUAL: "EQUAL"
}

export {
    COLUMN_DATA_TYPE,
    COMPARISON
};
